export const yrclist = [
  {
    id: 1,
    point: "Indian Red Cross Society (IRCS) was established in 1920 under the Indian Red Cross Society Act and incorporated under Parliament Act XV of 1920. The act was last amended in 1992 and of rules was formed in 1994.",
  },
  {
    id: 2,
    point: "The IRCS has 36 State / Union Territories Branches with their more than 1100 districts and sub district branches.",
  },
  {
    id: 3,
    point: "Honourable President of India is the President and Hon'ble Union Health Minister is the Chairman of the Society.",
  },
  {
    id: 4,
    point: "The Vice Chairman is elected by the members of the Managing Body.",
  },
  {
    id: 5,
    point: "The National Managing Body consists of 19 members.",
  },
  {
    id: 6,
    point: "The Chairman and 6 members are nominated by the President. The remaining 12 are elected by the state and union territory branches through an electoral college.",
  },
  {
    id: 7,
    point: "The Managing Body is responsible for governance and supervision of the functions of the society through a number of committees.",
  },
  {
    id: 8,
    point: "The Secretary General is the Chief Executive of the Society.",
  },
];
